import React, {
  useState,
  useContext,
} from "react";

import { useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import {
  FaFileInvoiceDollar,
  FaPlus,
  FaTrash,
  FaCalculator,
  FaUser,
  FaBuilding,
} from "react-icons/fa";

import {
  ProductContext
} from "../context/ProductContext";

import "../styles/GSTBilling.css";

function GSTBilling() {

  const [invoiceNo, setInvoiceNo] = useState(
  `AAP/${new Date().getFullYear()}/0001`
);

const [invoiceDate, setInvoiceDate] = useState(
  new Date().toISOString().split("T")[0]
);

const [customerPhone, setCustomerPhone] = useState("");

const [customerState, setCustomerState] = useState("");

const [customerStateCode, setCustomerStateCode] = useState("");

const [transportMode, setTransportMode] = useState("");

const [referenceCode, setReferenceCode] = useState("");

const [dateOfSupply, setDateOfSupply] = useState("");

const [placeOfSupply, setPlaceOfSupply] = useState("");

const [reverseCharge, setReverseCharge] = useState("No");

const [businessState, setBusinessState] = useState("Tamil Nadu");

const [businessStateCode, setBusinessStateCode] = useState("33");

const [transportCharge, setTransportCharge] = useState(0);

  const navigate = useNavigate();

  const { products } =
    useContext(ProductContext);

  const [items, setItems] =
    useState([
      {
 product:"",
 hsn:"",
 qty:1,
 price:0,
 gst:18,
 total:0
},
    ]);

    const [customerName, setCustomerName] = useState("");

const [customerAddress, setCustomerAddress] = useState("");

const [customerGST, setCustomerGST] = useState("");

const [businessName, setBusinessName] = useState("");

const [businessGST, setBusinessGST] = useState("");

const [businessAddress, setBusinessAddress] = useState("");

  const addRow = () => {

    setItems([

      ...items,

      {
        product: "",
        qty: 1,
        price: 0,
        gst: 18,
        total: 0,
      },

    ]);
  };

  const removeRow = (index) => {

    const updated =
      [...items];

    updated.splice(index, 1);

    setItems(updated);
  };

  const handleItemChange = (
    index,
    field,
    value
  ) => {

    const updated =
      [...items];

    updated[index][field] =
      value;

    const qty =
      Number(updated[index].qty);

    const price =
      Number(updated[index].price);

    const gst =
      Number(updated[index].gst);

    const subtotal =
      qty * price;

    const gstAmount =
      subtotal * gst / 100;

    updated[index].total =
      subtotal + gstAmount;

    setItems(updated);
  };

  const subtotal =
    items.reduce(

      (sum, item) =>

        sum +

        (
          Number(item.qty) *
          Number(item.price)
        ),

      0
    );

  const gstTotal =
    items.reduce(

      (sum, item) =>

        sum +

        (
          (
            Number(item.qty) *
            Number(item.price)
          )

          *

          Number(item.gst)

          / 100
        ),

      0
    );

  const grandTotal =
subtotal +
gstTotal +
Number(transportCharge);

  const generatePDF = () => {

  const doc = new jsPDF();

  // ===== HEADER =====

  doc.setFillColor(10, 25, 60);

  doc.rect(0, 0, 220, 30, "F");

  doc.setTextColor(255, 255, 255);

  doc.setFontSize(24);

  doc.text("TAX INVOICE", 14, 18);

  // ===== COMPANY =====

  doc.setTextColor(0, 0, 0);

  doc.setFontSize(14);

  doc.text("MyOwnBill Pvt Ltd", 14, 40);

  doc.setFontSize(11);

  doc.text(
    "Chennai, Tamil Nadu",
    14,
    47
  );

  doc.text(
    "GSTIN: 33ABCDE1234F1Z5",
    14,
    54
  );

  // ===== INVOICE INFO =====

  doc.text(
    "Invoice No: INV-1001",
    140,
    40
  );

  doc.text(
    `Date: ${new Date().toLocaleDateString()}`,
    140,
    47
  );

  // ===== CUSTOMER =====

  doc.setFontSize(13);

  doc.text("Bill To:", 14, 70);

  doc.setFontSize(11);

  doc.text(customerName || "-", 14, 78);

  doc.text(customerAddress || "-", 14, 85);

  doc.text(
  `GSTIN: ${customerGST || "-"}`,
  14,
  92
);

  // ===== TABLE =====

  autoTable(doc, {

    startY: 105,

    head: [[
      "Product",
      "HSN",
      "Qty",
      "Rate",
      "GST",
      "Total",
    ]],

    body: items.map((item) => [

      item.product || "Product",

      item.hsn || "1209",

      item.qty || 1,

      "Rs. " + (item.price || 0),

      `${item.gst || 18}%`,

      "Rs. " + (item.total || 0),

    ]),

    theme: "grid",

    headStyles: {
      fillColor: [10, 25, 60],
    },

  });

  // ===== TOTALS =====

  const finalY =
    doc.lastAutoTable.finalY + 15;

  doc.setFontSize(12);

  doc.text(
    `Subtotal: Rs.${subtotal.toFixed(2)}`,
    140,
    finalY
  );

  doc.text(
    `CGST: Rs.${(gstTotal / 2).toFixed(2)}`,
    140,
    finalY + 8
  );

  doc.text(
    `SGST: Rs.${(gstTotal / 2).toFixed(2)}`,
    140,
    finalY + 16
  );

  // ===== GRAND TOTAL =====

  doc.setFillColor(240, 240, 240);

  doc.rect(
    130,
    finalY + 24,
    65,
    14,
    "F"
  );

  doc.setFontSize(15);

  doc.text(
    `Grand Total: Rs.${grandTotal.toFixed(2)}`,
    135,
    finalY + 33
  );

  // ===== FOOTER =====

  doc.setFontSize(10);

  doc.text(
    "Thank you for your business!",
    14,
    280
  );

  doc.text(
    "Authorized Signature",
    150,
    280
  );

  // ===== SAVE =====

  doc.save("GST-Invoice.pdf");

};

  return (

    <div className="gst-page">

      <div className="gst-header">

        <div>

          <h1>
            GST Billing
          </h1>

          <p>
            Create professional GST tax invoices
            with automatic calculations.
          </p>

        </div>

        <button
  className="save-btn"
  onClick={generatePDF}
>

  <FaFileInvoiceDollar />

  Generate Invoice

</button>

      </div>

      <div className="gst-top-grid">

        {/* CUSTOMER */}

        <div className="gst-card">

          <div className="card-title">

            <FaUser />

            Customer Details

          </div>

          <div className="form-grid">

<input
value={customerName}
onChange={(e)=>setCustomerName(e.target.value)}
placeholder="Customer Name"
/>

<input
value={customerPhone}
onChange={(e)=>setCustomerPhone(e.target.value)}
placeholder="Phone Number"
/>

<input
value={customerGST}
onChange={(e)=>setCustomerGST(e.target.value)}
placeholder="GSTIN"
/>

<input
value={customerState}
onChange={(e)=>setCustomerState(e.target.value)}
placeholder="State"
/>

<input
value={customerStateCode}
onChange={(e)=>setCustomerStateCode(e.target.value)}
placeholder="State Code"
/>

<textarea
value={customerAddress}
onChange={(e)=>setCustomerAddress(e.target.value)}
placeholder="Billing Address"
/>

</div>

        </div>

        {/* BUSINESS */}

        <div className="gst-card">

          <div className="card-title">

            <FaBuilding />

            Business Details

          </div>

          <div className="form-grid">

<input
value={businessName}
onChange={(e)=>setBusinessName(e.target.value)}
placeholder="Business Name"
/>

<input
value={businessGST}
onChange={(e)=>setBusinessGST(e.target.value)}
placeholder="Business GSTIN"
/>

<input
value={invoiceNo}
onChange={(e)=>setInvoiceNo(e.target.value)}
placeholder="Invoice Number"
/>

<input
type="date"
value={invoiceDate}
onChange={(e)=>setInvoiceDate(e.target.value)}
/>

<input
value={transportMode}
onChange={(e)=>setTransportMode(e.target.value)}
placeholder="Transport Mode"
/>

<input
value={referenceCode}
onChange={(e)=>setReferenceCode(e.target.value)}
placeholder="Reference Code"
/>

<input
type="date"
value={dateOfSupply}
onChange={(e)=>setDateOfSupply(e.target.value)}
/>

<input
value={placeOfSupply}
onChange={(e)=>setPlaceOfSupply(e.target.value)}
placeholder="Place Of Supply"
/>

<select
value={reverseCharge}
onChange={(e)=>setReverseCharge(e.target.value)}
>
<option>No</option>
<option>Yes</option>
</select>

</div>

        </div>

      </div>

      {/* PRODUCTS */}

      <div className="gst-card">

        <div className="table-header">

          <h2>
            Invoice Items
          </h2>

          <button
            className="add-btn"
            onClick={addRow}
          >

            <FaPlus />

            Add Item

          </button>

        </div>

        <table className="gst-table">

          <thead>

            <tr>

              <th>Product</th>
              <th>HSN</th>
              <th>Qty</th>
              <th>Rate</th>
              <th>GST%</th>
             <th>Taxable</th>
              <th>Total</th>

            </tr>

          </thead>

          <tbody>

            {items.map(
              (item, index) => (

                <tr key={index}>

                  <td>

                    <select

                      value={item.product}

                      onChange={(e) => {

                        const selected =
                          products.find(

                            p =>

                              p.name ===
                              e.target.value
                          );

                        handleItemChange(
                          index,
                          "product",
                          e.target.value
                        );

                        if (selected) {

                          handleItemChange(
                            index,
                            "price",

                            selected.price
                              ?.replace("₹", "")
                          );
                        }

                      }}
                    >

                      <option>
                        Select Product
                      </option>

                      {products.map(
                        (product, i) => (

                          <option
                            key={i}
                            value={product.name}
                          >

                            {product.name}

                          </option>

                        )
                      )}

                    </select>

                  </td>

                  <td>

                    <input
                      type="number"
                      value={item.qty}
                      onChange={(e) =>
                        handleItemChange(
                          index,
                          "qty",
                          e.target.value
                        )
                      }
                    />

                  </td>

                  <td>

                    <input
                      type="number"
                      value={item.price}
                      onChange={(e) =>
                        handleItemChange(
                          index,
                          "price",
                          e.target.value
                        )
                      }
                    />

                  </td>

                  <td>

                    <select
                      value={item.gst}
                      onChange={(e) =>
                        handleItemChange(
                          index,
                          "gst",
                          e.target.value
                        )
                      }
                    >

                      <option value="0">
                        0%
                      </option>

                      <option value="5">
                        5%
                      </option>

                      <option value="12">
                        12%
                      </option>

                      <option value="18">
                        18%
                      </option>

                      <option value="28">
                        28%
                      </option>

                    </select>

                  </td>

                  <td>

                    ₹
                    {item.total.toFixed(2)}

                  </td>

                  <td>

                    <button
                      className="delete-btn"

                      onClick={() =>
                        removeRow(index)
                      }
                    >

                      <FaTrash />

                    </button>

                  </td>

                </tr>

            ))}

          </tbody>

        </table>

      </div>

      {/* TOTALS */}

      <div className="gst-summary">

        <div className="summary-card">

          <div className="summary-title">

            <FaCalculator />

            Invoice Summary

          </div>

          <div className="summary-row">

            <span>Subtotal</span>

            <strong>
              ₹{subtotal.toFixed(2)}
            </strong>

          </div>

          <div className="summary-row">

            <span>Total GST</span>

            <strong>
              ₹{gstTotal.toFixed(2)}
            </strong>

          </div>

          <div className="summary-row">

<span>Transport Charge</span>

<input
type="number"
value={transportCharge}
onChange={(e)=>setTransportCharge(Number(e.target.value))}
style={{width:"100px"}}
/>

</div>

          <div className="summary-row total">

            <span>Grand Total</span>

            <strong>
              ₹{grandTotal.toFixed(2)}
            </strong>

          </div>

        </div>

      </div>

    </div>
  );
}

export default GSTBilling;